import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

interface TextSelectedItemsProps {
  selectedItems: number;
}

const TextSelectedItems = ({ selectedItems }: TextSelectedItemsProps) => {
  const { t } = useTranslation();
  return (
    <Row>
      <Col sm={6}>
        <span style={{ color: 'red' }}>
          {selectedItems === 1
            ? t('SelectedItem', { items: selectedItems })
            : t('SelectedItems', { items: selectedItems })}
        </span>
      </Col>
    </Row>
  );
};
export default TextSelectedItems;
